module.exports = __webpack_public_path__ + "static/media/icon-arrow.431dd69d.svg";